import { formatImageBytes } from './imageProcessor';
import { show_app_toast } from '../appToast';

/**
 * @param {import('i18next').TFunction} t
 * @param {object} report
 */
export function showImageOptimizationNotification(t, report) {
    if (!report?.modified)
        return;

    const parts = [];

    if (report.resized) {
        parts.push(t('image_upload.notification_resized', {
            fromWidth: report.originalWidth,
            fromHeight: report.originalHeight,
            toWidth: report.finalWidth,
            toHeight: report.finalHeight,
        }));
    }

    const fromSize = formatImageBytes(report.originalBytes);
    const toSize = formatImageBytes(report.finalBytes);

    if (report.savedBytes > 0 && fromSize !== toSize) {
        parts.push(t('image_upload.notification_saved', {
            fromSize,
            toSize,
        }));
    }

    if (!parts.length)
        return;

    show_app_toast(parts.join(' '), { variant: 'info' });
}
